import { all, fork, takeEvery, takeLatest } from "redux-saga/effects";
import { SagaActions } from "./actionTypes";

import {
  addErrorLogsAction,
  addInfoLogsAction,
  addNewUUIDAction,
  addUserIDAction,
  addWarnLogsAction,
  clearLogs,
} from "./slices/logsSlice/logSlice";
import { getClientsListAction } from "./slices/clients/clientsListSlice";
import { getPlansList } from "./slices/plansSlice/plansSlice";
import { fetchProfileDetails } from "./slices/userSlices/profileSlice";

function* logSaga() {
  yield takeLatest(SagaActions.ERROR, addErrorLogsAction);
  yield takeLatest(SagaActions.WARN, addWarnLogsAction);
  yield takeLatest(SagaActions.INFO, addInfoLogsAction);
  yield takeLatest(SagaActions.ADD_NEW_UUID, addNewUUIDAction);
  yield takeLatest(SagaActions.CLEAR_LOGS, clearLogs);
  yield takeLatest(SagaActions.ADD_USERID, addUserIDAction);
  yield takeLatest(SagaActions.GET_PLANS, getPlansList);
}

function* clientSaga() {
  yield takeLatest(SagaActions.ADD_CLIENTS_LIST, getClientsListAction);
}

function* mainSaga() {
  yield takeLatest(SagaActions.FETCH_PROFILE, fetchProfileDetails);
}

export default function* rootSaga() {
  yield all([fork(mainSaga), fork(logSaga), fork(clientSaga)]);
}
